import { render, staticRenderFns } from "./WizardAiChat.vue?vue&type=template&id=36b3e54c&scoped=true"
import script from "./WizardAiChat.vue?vue&type=script&lang=js"
export * from "./WizardAiChat.vue?vue&type=script&lang=js"
import style0 from "./WizardAiChat.vue?vue&type=style&index=0&id=36b3e54c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b3e54c",
  null
  
)

export default component.exports